import React, { useContext } from 'react'

import { SectionContext } from '../../../contexts/section-context'
import { FetchPriority, Loading, ImageProps } from './types'
import { useIsInternalTesting } from '../hooks/use-internal-testing'
import styles from './image.module.scss'

export const useImageLoadingProps = (): Partial<{ fetchpriority: FetchPriority; loading: Loading }> => {
  const isInternalTesting = useIsInternalTesting()
  const { isHero, indexInPage, isTrustedBySection } = useContext(SectionContext)

  if (isInternalTesting) {
    return {}
  }

  return isHero
    ? {
        fetchpriority: 'high',
      }
    : indexInPage === 1 || isTrustedBySection
      ? {}
      : {
          loading: 'lazy',
        }
}

export const Image: React.FC<ImageProps> = ({ alt, ...props }) => {
  const loadingPriorityProps = useImageLoadingProps()

  return <img alt={alt} {...loadingPriorityProps} {...props} className={props.className} />
}

export const containedImageStyle = styles.containedImage
